import { DownOutlined, FileDoneOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";

export const ActionsDropdownBtn = ({
  menuItems = [],
  onItemsClick,
  icon,
  text = null,
  displayText = true,
  loadingBtn = false,
  ...restProps
}) => {
  return (
    <Dropdown menu={{ items: menuItems, onClick: onItemsClick }}>
      <Button
        onClick={(e) => e.preventDefault()}
        color="cyan"
        variant="outlined"
        loading={loadingBtn}
        disabled={loadingBtn}
        {...restProps}
      >
        <Space>
          {!icon ? <FileDoneOutlined /> : icon}
          {displayText && (text == null ? "Acciones" : text)}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};
